








































































































import { Component, Mixins } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import OrganizationSearch from '@/components/organization-search/index.vue';
import EditableTree from '@/components/data-layout/editable-tree.vue';
import AddEditModal from './components/add-edit-modal.vue';
import TransferModal from './components/transfer-modal.vue';
import { getOrgDepList, deleteOrgDep, listLeftTree } from '@/api/system-management/index';
import * as _ from 'lodash';
import toTree, { ITreeNode } from '@root/utils/to-tree';
import checkAuthority from '@root/utils/check-authority';
import { Getter } from 'vuex-class';
import { isShiDaill } from '@/utils/env';

@Component({
  name: 'OrganizationList',
  components: { OrganizationSearch, EditableTree, AddEditModal, TransferModal }
})
export default class OrganizationList extends Mixins(TableMixin, TableWidthMixin) {
  isShiDaill = isShiDaill;
  // 查询条件
  orgDepId: string | null = null; // 机构id
  orgDepCode = ''; // 机构编码
  // 机构选择树，当前用户所在及以下的机构列表
  orgDepTree: ITreeNode<any>[] = [];
  // 机构选择树展开内容项
  orgDepTreeFirstKeys: string[] | null = null;

  // 表数据
  tableDataAll: any[] = [];
  tableData: any[] = [];
  tableLoading = false;

  // 弹窗控制
  addEditModalVisible: boolean = false;
  isEdit: boolean = false;
  addEditModalData: any = [];
  transferModalVisible: boolean = false; // 岗位设置弹窗是否显示
  orgDataToPosition = {}; // 岗位设置的机构信息
  targetKeysToPosition = []; // 岗位设置的当前选中项
  orgDepType = ''; //树节点类型 saas 顶级节点 root二级节点 child其他
  isRoot = false; //是否是二级节点
  isInherit = false; //是否继承
  treeLoading = false; //树形列表加载
  canAddNode = true;
  canDeleteNode = true;

  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'tree',
        hiddenHeader: true,
        width: '300px',
        padding: '20px'
      },
      {
        id: 'table',
        title: '机构列表',
        padding: '20px 30px 30px'
      }
    ];
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 72,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '机构名称',
        dataIndex: 'orgDepName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '机构编码',
        dataIndex: 'orgDepCode',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '上级机构',
        dataIndex: 'parentName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '地址',
        dataIndex: 'address',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '联系人',
        dataIndex: 'leader',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '联系方式',
        dataIndex: 'phone',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 220,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  @Action('organizations/fetchUserOrg')
  fetchUserOrg(params?: { force: boolean }) {} // 获取组织机构信息

  @Getter('user/permissions')
  permissions!: [];
  /**
   * 生命周期
   */

  async created() {
    // 查询表格数据
    // this.getOrgDepList(null)
    this.fetchTableData();
    this.getNewTreeList();
    const permissions1: string[] = window.rootStore.getters['user/permissions'] as string[];
  }
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.canAddNode = checkAuthority('system:org-dep:add-or-update');
        this.canDeleteNode = checkAuthority('system:org-dep:delete');
        console.log(checkAuthority('smart-parking::platform-business-config:edit'));
      }, 2000);
    });
  }
  selectNode = '';
  /**
   * method
   */

  async fetchTableData(orgDepId?: any) {
    // XXX: 为了树状图跟随查询条件，此处树状图和table共用查询条件一次性查9999条记录，前端自行分页
    // if (this.total < (this.current - 1) * this.pageSize) {
    //   // 处理当选择下一页后，在重新筛选查询，查询数据少于前一次页数，当前页重置为1
    //   this.current = 1
    // }
    // const startIndex = (this.current - 1) * this.pageSize
    // this.tableData = this.tableDataAll.slice(startIndex, startIndex + this.pageSize)

    /**
     * 分页查询，多查询一次
     */
    if (this.tableLoading) return false;
    this.tableLoading = true;
    try {
      const { data } = await getOrgDepList({
        currPage: this.current,
        pageSize: this.pageSize,
        orgDepId: orgDepId ? orgDepId : this.orgDepId,
        orgDepCode: this.orgDepCode
      });
      const { datas = [], totalNum = 0 } = data || {};
      this.tableData = datas;
      this.total = Number(totalNum);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  onSelectNode(data: { node: string }) {
    this.selectNode = data.node;
    //this.getOrgDepList(this.selectNode, false)
    this.fetchTableData(this.selectNode);
  }

  /**
   * 查询表格列表
   */
  async getOrgDepList(orgDepId: any, isLoading?: boolean) {
    if (this.tableLoading) return false;
    this.tableLoading = true;
    try {
      const { data } = await getOrgDepList({
        // currPage: this.current,
        // pageSize: this.pageSize,
        // 全数据查询，便于树状图处理
        currPage: 1,
        pageSize: 9999,
        orgDepId: orgDepId ? orgDepId : this.orgDepId,
        orgDepCode: this.orgDepCode
        // ...this.getSearchParam(),
      });
      const { datas = [], totalNum = 0 } = data || {};
      // 分页处理，查询全部数据，前端自行分页处理
      this.total = Number(totalNum);
      this.tableDataAll = datas;

      // this.fetchTableData()
      // 设置树状图信息
      if (!orgDepId) {
        const orgDepTree = toTree(datas, {
          idProp: 'orgDepId',
          parentProp: 'parentId',
          titleProp: 'orgDepName',
          keyFieldMap: 'value',
          titleFieldMap: 'title'
        }) as any;
        // 树状图第一级元素id
        this.orgDepTree = orgDepTree;
        const orgDepTreeFirstKey = orgDepTree && orgDepTree[0] && orgDepTree[0].key;
        if (orgDepTreeFirstKey) {
          this.orgDepTreeFirstKeys = [orgDepTreeFirstKey];
        }
      } else {
        if (isLoading) {
          this.getTreeList();
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //获取树形列表
  async getTreeList() {
    if (this.treeLoading) return false;
    this.treeLoading = true;
    try {
      const { data } = await getOrgDepList({
        currPage: 1,
        pageSize: 9999,
        orgDepId: '',
        orgDepCode: this.orgDepCode
      });
      const { datas = [] } = data || {};
      const orgDepTree = toTree(datas, {
        idProp: 'orgDepId',
        parentProp: 'parentId',
        titleProp: 'orgDepName',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      }) as any;
      // 树状图第一级元素id
      this.orgDepTree = orgDepTree;
      const orgDepTreeFirstKey = orgDepTree && orgDepTree[0] && orgDepTree[0].key;
      if (orgDepTreeFirstKey) {
        this.orgDepTreeFirstKeys = [orgDepTreeFirstKey];
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.treeLoading = false;
    }
  }
  /**
   * 整合列表查询参数
   * 机构查询和机构编码查询条件不同时存在，互相清空
   */
  // searchType = 'orgDepId' // 查询条件下拉框当前值
  // 查询条件下拉框选项
  // get searchOption() {
  //   return [
  //     {
  //       value: 'orgDepId',
  //       label: '机构名称',
  //     },
  //     {
  //       value: 'orgDepCode',
  //       label: '机构编码',
  //     },
  //   ]
  // }
  // getSearchParam() {
  //   const paramInner = {
  //     orgDepId: '',
  //     orgDepCode: '',
  //   }
  //   if (this.searchType === 'orgDepId') {
  //     this.orgDepCode = ''
  //     paramInner.orgDepId = this.orgDepId as string
  //   } else if (this.searchType === 'orgDepCode') {
  //     this.orgDepId = ''
  //     paramInner.orgDepCode = this.orgDepCode
  //   }
  //   return paramInner
  // }

  /**
   * 查询条件清空
   */
  onTableFilterClear() {
    this.orgDepCode = '';
    this.orgDepId = null;
    this.searchList();
  }

  /**
   * 岗位设置
   */
  onTableRoleSet(Item: any) {
    this.isRoot = Item.orgDepType == 'root';
    this.isInherit = Item.inherit == '0' || false;
    this.orgDataToPosition = {
      orgDepId: Item.orgDepId,
      orgDepName: Item.orgDepName,
      parentName: Item.parentName
    };
    this.targetKeysToPosition = Item.positionList;
    this.transferModalVisible = true;
  }

  /**
   * 表格行删除
   */
  deleteConfirm(key: string, item: any) {
    this.$confirm({
      title: '确定删除此机构吗?',
      onOk: () => {
        this.deleteItem(key, item);
      }
    });
  }
  async deleteItem(key: string, item: any) {
    try {
      const { status, code, msg, data } = await deleteOrgDep({
        orgDepId: key
      });
      this.$message.success('删除成功');
      // 查询表格数据
      // await this.getOrgDepList(this.selectNode, true)
      this.fetchTableData(this.selectNode);
      this.getNewTreeList();
      this.fetchUserOrg({ force: true });
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  /**
   * 新建弹窗展示
   */
  showAddModal(key: string, item: any) {
    if (item.orgDepType == 'saas') {
      this.isRoot = true;
    } else this.isRoot = false;
    this.orgDepType = item.orgDepType || '';
    this.isEdit = false;
    this.addEditModalData = {
      parentId: key,
      parentName: item.orgDepName
    };
    this.addEditModalVisible = true;
  }

  /**
   * 编辑弹窗展示
   */
  showEditModal(key: string, item: any) {
    if (item.orgDepType == 'root') {
      this.isRoot = true;
    } else this.isRoot = false;
    this.orgDepType = item.orgDepType || '';
    this.isEdit = true;
    this.addEditModalData = item;
    this.addEditModalVisible = true;
  }

  /**
   * 弹窗取消
   */
  handleModalCancel() {
    this.addEditModalVisible = false;
  }
  /**
   * 弹窗保存
   */
  async handleModalCreate() {
    this.addEditModalVisible = false;
    // 查询表格数据
    // await this.getOrgDepList(this.selectNode, true)
    this.fetchTableData(this.selectNode);
    this.getNewTreeList();
    // 更新缓存中机构列表数据
    this.fetchUserOrg({ force: true });
  }

  /**
   * 穿梭框弹窗成功
   */
  handleTransferModalOk() {
    this.transferModalVisible = false;
    // 查询表格数据
    // this.getOrgDepList(this.selectNode, true)
    this.fetchTableData(this.selectNode);
    this.getNewTreeList();
  }
  /**
   * 穿梭框弹窗取消
   */
  handleTransferModalCancel() {
    this.transferModalVisible = false;
  }
  /**
   *  获取组织树结构
   */
  async getNewTreeList() {
    if (this.treeLoading) return false;
    this.treeLoading = true;
    try {
      const { data } = await listLeftTree({
        orgDepId: this.orgDepId,
        orgDepCode: this.orgDepCode
      });
      // const { datas = [] } = data || {}
      const orgDepTree = toTree(data as any, {
        idProp: 'orgDepId',
        parentProp: 'parentId',
        titleProp: 'orgDepName',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      });
      // 树状图第一级元素id
      this.orgDepTree = orgDepTree;
      const orgDepTreeFirstKey = orgDepTree && orgDepTree[0] && orgDepTree[0].key;
      if (orgDepTreeFirstKey) {
        this.orgDepTreeFirstKeys = [orgDepTreeFirstKey];
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.treeLoading = false;
    }
  }
  //搜索条件查询
  searchList() {
    this.current = 1;
    this.fetchTableData(this.selectNode);
    this.getNewTreeList();
  }
}
